module.exports = __webpack_public_path__ + "img/mail.3d7f91b5.svg";